import { useState, useEffect } from 'react';

import * as contractServices from '../../../../services/contractService';
import ContractsTable from '../contract/ContractsTable';

function CustomerContracts({ customerId }) {
    const [contracts, setContract] = useState([]);

    useEffect(() => {
        let page;
        contractServices
            .getAll(page || 1)
            .then((result) => {
                // console.log(result);
                setContract(
                    (state) => result.data
                        .sort((a, b) => b.contractId - a.contractId)
                        .filter((x) => x.customerId === Number(customerId))
                         || []
                );
                console.log(contracts);
                
            })
            .catch((err) => {
                console.log(err);
            });
    }, [customerId]);

    return (
        <div className="customer-contracts">
            <h2>Customer Contracts</h2>
                <ContractsTable data={contracts} service={contractServices}  />

            {/* Additional components or logic for displaying contracts can be added here */}
        </div>
    );
}

export default CustomerContracts;
// This component is a placeholder for displaying customer contracts.
